<div class="col-md-12 d-flex justify-content-center align-items-center flex-column text-center">
    <h3>
        <img src='../../../../assets/media/png/no-records-found4.png' width="150" height="150" />
    </h3>
    <h4>
        <span [innerHTML]="('TRANSLATE.MESSAGE_TEXT_NO_RECORDS_FOUND')| translate"></span>
    </h4>
</div>